import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["group"]

  connect() {
    this.groupTargets.forEach(group => {
      const key = "nav_group_" + group.dataset.navGroupId

      // Bootstrap fires these for all state changes, including clearMenus()-triggered closes
      group.addEventListener("shown.bs.dropdown", () => {
        localStorage.setItem(key, "open")
      })
      group.addEventListener("hidden.bs.dropdown", () => {
        localStorage.setItem(key, "closed")
      })
    })

    // setTimeout(0) queues restore as a macrotask so it runs after Tabler's
    // turbo:load handlers (which collapse non-active groups) have completed
    this._restoreTimer = setTimeout(() => this.restoreState(), 0)
  }

  disconnect() {
    clearTimeout(this._restoreTimer)
  }

  restoreState() {
    this.groupTargets.forEach(group => {
      const toggle = group.querySelector('[data-bs-toggle="dropdown"]')
      const menu = group.querySelector('.dropdown-menu')
      if (!toggle || !menu) return

      const key = "nav_group_" + group.dataset.navGroupId
      const saved = localStorage.getItem(key)
      if (saved === null) return

      const isOpen = saved === "open"
      // Never collapse a group whose current path is inside it
      const isActive = group.dataset.navGroupActive === "true"
      if (!isOpen && isActive) return

      toggle.classList.toggle("show", isOpen)
      toggle.setAttribute("aria-expanded", String(isOpen))
      menu.classList.toggle("show", isOpen)
    })
  }
}
